// Login Routes
export const TOTAL_MARKETS = '/commercial/totalMarkets'
export const TOTAL_EASY_DRIVE = '/commercial/faciles_manejar'
export const TOTAL_ALTA_GAMA = '/commercial/alta_gama'
export const TOTAL_ENDURO = '/commercial/enduro'
export const TOTAL_STREET = '/commercial/street'
export const TOTAL_MARKET_SHARE = '/marketShare/company'
export const TOTAL_MARKET_EASYTODRIVER = '/marketShare/faciles_manejar'
export const TOTAL_MARKET_HIGH_RANGE = '/marketShare/alta_gama'
export const TOTAL_MARKET_ENDURO = '/marketShare/enduro'
export const TOTAL_MARKET_STREET = '/marketShare/street'
export const TOTAL_MARKET_TOTAL = '/marketShare/total'
export const MEI_IMPORTS_INDIVIDUAL = '/mei/individual'
export const MEI_MARKET = '/mei/mercado_motos'
export const MEI_MARKET_TOTAL_SALES = '/mei/total_ventas'
export const MEI_MARKET_TOTAL_ELECTRIC = '/mei/total_electric'
export const MEI_MARKET_ELECTRIC_BIKERS = '/mei/total_electric_bikes'
export const MEI_MARKET_SKATEBOARD = '/mei/total_skateboard'
export const MARKET_TOTAL_4W = '/4w/4w_total_market'
export const MARKET_TOTAL_PRODUCT = '/4w/4w_total_product'
export const MARKET_TOTAL_3W = '/3w/3w_total_market'
export const SPARE_PARTS_TOTAL = '/spare/total_spareparts'
export const SPARE_PARTS_ORIGINAL = '/spare/total_original'
export const SPARE_PARTS_ORIGINAL_INDIA = '/spare/total_original_india'
export const SPARE_PARTS_ORIGINAL_ESPECIAL = '/spare/total_original_special'
export const SPARE_PARTS_TYRES = '/spare/tyres'
export const SPARE_PARTS_BATERY = '/spare/battery'


















